import { render, staticRenderFns } from "./UpscaleFactorSlider.vue?vue&type=template&id=501e82f2&scoped=true"
import script from "./UpscaleFactorSlider.vue?vue&type=script&lang=ts"
export * from "./UpscaleFactorSlider.vue?vue&type=script&lang=ts"
import style0 from "./UpscaleFactorSlider.vue?vue&type=style&index=0&id=501e82f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e82f2",
  null
  
)

export default component.exports